import * as React from "react";
import {
  createStyles,
  withStyles,
  WithStyles,
  StyleRules
} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { GetFacilityUsersResponse } from "@api/requests/facility/getFacilityUsers";
import SectionTitle from "@components/atoms/SectionTitle";
import KnowbeButton from "@components/presentational/atoms/KnowbeButton";

const styles = (): StyleRules =>
  createStyles({
    paperContainer: {
      padding: "30px 32px 32px 32px",
      margin: 16
    },
    userRecord: {
      listStyle: "none",
      padding: 0,
      marginTop: 8,
      marginBottom: 0
    },
    noUserRecordSection: {
      padding: "80px 0 48px",
      textAlign: "center"
    },
    userRecordSection: {
      display: "flex",
      alignItems: "center",
      padding: "14px 16px",
      "&:nth-child(2n)": {
        backgroundColor: "#f5f5f5"
      },
      "&:last-child": {
        borderBottom: "1px solid rgba(0, 0, 0, 0.54)"
      }
    },
    userName: {
      margin: "0 auto 0 0",
      color: "rgba(0, 0, 0, 0.87)"
    },
    recordButton: {
      marginLeft: 8
    }
  });

type OwnProps = {
  users: GetFacilityUsersResponse["data"];
  buttons: { label: string; path: string }[];
};

type Props = OwnProps & WithStyles<typeof styles>;

const RecordEachUserBasicCore = (props: Props): JSX.Element => {
  const { classes } = props;
  return (
    <Paper elevation={0} className={classes.paperContainer}>
      <SectionTitle label="利用者ごとの記録" isTitleNoMargin />
      {props.users.length === 0 ? (
        <div className={classes.noUserRecordSection}>
          利用者が登録されていません。利用者情報画面で登録後、ご利用ください。
        </div>
      ) : (
        <ul className={classes.userRecord}>
          {props.users.map((user) => (
            <li key={user.uif_id} className={classes.userRecordSection}>
              <div className={classes.userName}>{user.displayName}</div>
              {props.buttons.map((button) => {
                const path = button.path.replace(":uifId", `${user.uif_id}`);
                return (
                  <KnowbeButton
                    key={`${user.uif_id}-${button.label}`}
                    kind="outlineWhite"
                    className={classes.recordButton}
                    href={path}
                  >
                    {button.label}
                  </KnowbeButton>
                );
              })}
            </li>
          ))}
        </ul>
      )}
    </Paper>
  );
};

export const RecordEachUserBasic = withStyles(styles)(RecordEachUserBasicCore);
